import React, { type FunctionComponent, useMemo } from 'react'
import { Text } from '@retailer-platform/shared-components'
import moment from 'moment-timezone'
import { useDomainMessage } from 'domains/products/utils/domain/intl'
import { ProductsSearchTableLazyDataCell } from 'domains/products/components/search/components/table/components/lazy-data-cell/ProductsSearchTableLazyDataCell'

interface Props {
  date: string
}

export const ProductsSearchTableDateCell: FunctionComponent<Props> = ({ date }) => {
  const errorTitle = useDomainMessage('productsDomain.search.dateUnavailable')
  const formattedDate = useMemo(() => {
    if (!date) return null
    const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone

    return moment(date).tz(localTz).format('l')
  }, [date])

  return (
    <ProductsSearchTableLazyDataCell errorTitle={errorTitle} error={!formattedDate} loading={false}>
      <Text>{formattedDate}</Text>
    </ProductsSearchTableLazyDataCell>
  )
}
